import { useCallback, useState } from "react";
import { fetchChatListPage, searchChatByPhone } from "../../models/chat/chatListModel";

// Thin state wrapper over the raw page fetch — full pagination/filter
// sophistication (continuation tokens, date-range scans, large-list
// warnings) stays in useWatiChatList.js, which already owns that.
export function useChatListPage() {
  const [list, setList] = useState([]);
  const [token, setToken] = useState(null);
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (payload) => {
    setLoading(true);
    const result = await fetchChatListPage(payload);
    setList(result.list);
    setToken(result.token);
    setCount(result.count);
    setLoading(false);
    return result;
  }, []);

  const searchByPhone = useCallback((userId, phone) => searchChatByPhone(userId, phone), []);

  return { list, token, count, loading, load, searchByPhone };
}
